module.exports = __webpack_public_path__ + "fonts/6b9ca17d-cb9d-43bb-8b43-93670b45b83f.bef645ea.ttf";